import type { ReactNode } from "react";
import { cx } from "../utils/cx.js";

export interface FieldProps {
  label?: ReactNode;
  required?: boolean;
  help?: ReactNode;
  error?: ReactNode;
  htmlFor?: string;
  className?: string;
  children: ReactNode;
}

/** Label + control + help/error wrapper shared by the form controls. */
export function Field({ label, required, help, error, htmlFor, className, children }: FieldProps) {
  return (
    <div className={cx("az-field", className)}>
      {label != null && (
        <label className="az-field__label" htmlFor={htmlFor}>
          {label}
          {required && <span className="az-field__required">*</span>}
        </label>
      )}
      {children}
      {error != null ? (
        <div className="az-field__error" role="alert">
          {error}
        </div>
      ) : help != null ? (
        <div className="az-field__help">{help}</div>
      ) : null}
    </div>
  );
}
